<template>
  <responsive-model v-model="isThreeSixtyActive" :style="{ height: '100%' }" closeable hide-action-btn>
    <template #title>
      <p class="text-center font-bold text-xl">{{ $t("product.three_sixty_mobile_title") }}</p>
    </template>
    <div class="p-3">
      <niceone-image :src="data?.manufacturer_image" width="60"/>
      <p class="py-1 font-bold">{{ data?.name }}</p>
      <van-divider/>
      <niceone-image :src="$publicPath('/images/360degree.svg')" class="w-12 mt-2"/>
      <p class="py-1 font-bold text-gray-500">{{ $t("product.three_sixty_instruction") }}</p>
    </div>
    <product-three-sixty-degree :threeSixtyImages="data?.images360"/>
  </responsive-model>
</template>

<script setup>
import ResponsiveModel from "@/components/common/dialogs/responsive";
import ProductThreeSixtyDegree from "@/components/ProductThreeSixtyDegree";
import {EVENTS} from "@/constants/events";

defineProps({
  data: {
    type: Object,
    default: () => {
    }
  }
});

const isThreeSixtyActive = ref(false);
const {on: openThreeSixtyPopup} = useEventBus(EVENTS.THREE_SIXTY_POPUP);
openThreeSixtyPopup(() => isThreeSixtyActive.value = !isThreeSixtyActive.value);
</script>

<style lang="scss" scoped></style>